import { SimpleEntityGridActionCellButton } from "src/app/components/grid/CellRenderer/SimpleEntityGridActionCell/SimpleEntityGridActionCell";

export type TActionButton = {
    actions: SimpleEntityGridActionCellButton[];
    name: SimpleEntityGridActionCellButton;
    actionsCondition?(data: any): boolean;
    data: any;
    disable?(data: any): boolean;
    children: React.ReactElement;
};

const ActionButton = ({
    actions,
    actionsCondition,
    disable,
    data,
    name,
    children,
}: TActionButton) => {
    return (
        <>
            {actions.includes(name) && (
                <>
                    {(!actionsCondition || actionsCondition(data)) && (
                        <div className={disable && disable(data) ? "actionButton-disable" : ""}>
                            {children}
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default ActionButton;
